import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GetItemMasterMainGridData } from "../../../../services/SalesOrderService";
import ItemMasterSearchResultsMain from "./ItemMasterSearchResultsMain";
import ItemMasterFilters from "./ItemMasterFilters";

const ItemMaster = (props) => {
    const getSalesOrderUrl = "om/SaleOrder/GetItemMasterMain";
    const [dataSource, setDataSource] = useState(null);

    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

 
    const searchData = (formFieldss) => {
        var resultData = GetItemMasterMainGridData(accessToken, getSalesOrderUrl, formFieldss);
        setDataSource(resultData);
    };
    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <ItemMasterFilters currentUser={currentUser} DYNAMICFORMSETTING={DYNAMICFORMSETTING} searchData={searchData} />
                        <ItemMasterSearchResultsMain data={dataSource} />
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemMaster);